import React, { useState, useRef } from 'react';
import LanguageProvider from 'providers/LanguageProvider';
import Popover from '../../../../components/Popover';
import Checkbox from '../../../../components/Checkbox';
import { addFlux } from 'components/wrappers/WithFlux';
import classnames from 'classnames';
import ChevronIcon from 'components/icons/ChevronIcon';
import { useCurrencyContext } from '~/context/CurrencyContext';
import CurrencyList from 'utils/CurrencyList';
import useClickOutside from 'hooks/useClickOutside';

const CSS = require('./LanguageCurrencyPopover.less');

interface LanguageCurrencyPopoverProps {
  transparent?: boolean;
  flux: any;
  languageName: string;
  languages: [{ code: string; name: string }];
  language: string;
}

function LanguageCurrencyPopover({ flux, languageName, languages, language, transparent }: LanguageCurrencyPopoverProps) {
  const [show, setShow] = useState(false);
  const { state, actions } = useCurrencyContext();
  const togglePopover = () => setShow(!show);
  const closePopover = () => setShow(false);
  const ref = useRef(null);
  useClickOutside(ref, () => setShow(false));

  const onLanguageClick = event => {
    setShow(false);
    const langCode = event.target.value.toLowerCase();
    flux.actions.translations.setLanguageCode(langCode);
  };

  const onCurrencyClick = (event) => {
    setShow(false);
    actions.setCurrency(event.target.value);
  };

  return (
    <div className={CSS.LanguageCurrencyPopover} ref={ref}>
      <button className={classnames(CSS.Button, { [CSS.ButtonTransparent]: transparent })} onClick={togglePopover}>
        <span>{languageName}{' / '}{state.currency}</span>
        <ChevronIcon
          className={classnames(CSS.Icon, { [CSS.IconRotated]: show, [CSS.IconTransparent]: transparent })}
          width={9}
          height={5}
          direction="bottom"
        />
      </button>
      <Popover
        className={CSS.Popover}
        show={show}
        name="languageCurrencyPopover"
        underNavbar
        onClose={closePopover}
      >
        <div className={CSS.PopoverContent}>
          <div className={CSS.Languages}>
            <h4 className={CSS.Title}>Languages</h4>
            <ul>
              {languages.map(({ name, code }) => {
                return (
                  <li key={name} className={CSS.ListItem}>
                    <Checkbox value={code} onChange={onLanguageClick} checked={language.toLowerCase() === code.toLowerCase()}>
                      {name}
                    </Checkbox>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={CSS.Currency}>
            <h4 className={CSS.Title}>Currency</h4>
            <ul className={CSS.CurrencyList}>
              {CurrencyList.map(({ symbol_native, code }) =>
                <li key={code} className={CSS.ListItem}>
                  <Checkbox value={code} onChange={onCurrencyClick} checked={state.currency.toLowerCase() === code.toLowerCase()}>
                    <span className={CSS.Symbol}>{symbol_native}</span><span>{code}</span>
                  </Checkbox>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Popover>
    </div>
  );
}

function LanguageCurrencyPopoverContainer(props) {
  return (
    <LanguageProvider>
      {({ language, languages }) => {
        const languageName = languages.find(({ code }) => code === language.toLowerCase()).name;
        return (
          <LanguageCurrencyPopover
            languageName={languageName}
            language={language}
            languages={languages}
            {...props}
          />
        );
      }}
    </LanguageProvider>
  );
}

export default addFlux(LanguageCurrencyPopoverContainer);
